(function(){
  'use strict';

  document.documentElement.classList.add('hw-js');

  /*
    Scroll-scrubbed hero video + scroll story.

    Timeline (hero progress 0 -> 1):
      .00-.14  intro copy fades out
      .14-.66  three text beats while the sheet comes off, bats cross the frame
      .66-.86  fog thins out
      .74-.88  finale: title + CTA land over the revealed dog, and stay
    No forced scroll at the end: the stage simply releases and the page
    continues into the intro.
  */

  function clamp(v,a,b){return Math.max(a,Math.min(b,v));}
  function smooth(a,b,v){var p=clamp((v-a)/(b-a),0,1);return p*p*(3-2*p);}
  function bell(v,a,b,c,d){return smooth(a,b,v)*(1-smooth(c,d,v));}

  var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData=Boolean(navigator.connection&&navigator.connection.saveData);

  /* ---------- Scroll-in reveals + bat dividers (whole page) ---------- */
  var risers=[].slice.call(document.querySelectorAll('.hw-rise,.hw-sep'));
  if(risers.length){
    if('IntersectionObserver' in window&&!reduced){
      var riseIO=new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){e.target.classList.add('is-risen');riseIO.unobserve(e.target);}
        });
      },{rootMargin:'0px 0px -12% 0px',threshold:.08});
      risers.forEach(function(el){riseIO.observe(el);});
    }else{
      risers.forEach(function(el){el.classList.add('is-risen');});
    }
  }

  /* ---------- Fog under product cards ---------- */
  var cards=[].slice.call(document.querySelectorAll('.night-card__photo,.collection--halloween .pcard__media,.pdp--halloween .gal__slide'));
  var visibleCards=[];
  function updateCards(){
    var vh=window.innerHeight||800;
    for(var i=0;i<visibleCards.length;i++){
      var card=visibleCards[i];
      var rect=card.getBoundingClientRect();
      var p=clamp((vh*.88-rect.top)/(vh*.88+rect.height),0,1);
      card.style.setProperty('--card-fog-x',((p-.5)*34).toFixed(1)+'px');
    }
  }
  var cardFrame=0;
  function requestCards(){if(!cardFrame)cardFrame=requestAnimationFrame(function(){cardFrame=0;updateCards();});}
  if(cards.length&&!reduced&&'IntersectionObserver' in window){
    var cardIO=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        var i=visibleCards.indexOf(e.target);
        if(e.isIntersecting&&i<0)visibleCards.push(e.target);
        if(!e.isIntersecting&&i>=0)visibleCards.splice(i,1);
      });
      requestCards();
    });
    cards.forEach(function(c){cardIO.observe(c);});
    window.addEventListener('scroll',function(){if(visibleCards.length)requestCards();},{passive:true});
  }

  /* ---------- Hero ---------- */
  var hero=document.querySelector('[data-night-hero]');
  if(!hero)return;

  var stage=hero.querySelector('.night-hero__stage');
  var video=hero.querySelector('[data-scroll-video]');

  var FPS=24;
  var EASE=0.28;
  var SCRUB_FROM=0.03;
  var SCRUB_TO=0.8;

  var duration=0,shown=0;
  var heroTop=0,travel=1,stickyTop=0;
  var inView=false,running=false,loaded=false,ready=false;
  var lastProgress=-1,finaleOn=false;

  if(reduced||saveData||!video){
    hero.classList.add('is-static');
    if(video)video.remove();
  }

  function measure(){
    var rect=hero.getBoundingClientRect();
    heroTop=rect.top+window.scrollY;
    stickyTop=parseFloat(getComputedStyle(stage).top)||0;
    travel=Math.max(1,hero.offsetHeight-stage.offsetHeight);
  }

  function progress(){
    return clamp((window.scrollY+stickyTop-heroTop)/travel,0,1);
  }

  function paint(p){
    if(hero.classList.contains('is-static'))return;
    if(Math.abs(p-lastProgress)<0.0005)return;
    lastProgress=p;
    var s=hero.style;

    var copyOut=smooth(.03,.14,p);
    var finale=smooth(.74,.88,p);
    var batP=clamp((p-.12)/.56,0,1);

    s.setProperty('--night-scroll',p.toFixed(4));
    s.setProperty('--hero-scale',(1+p*.04).toFixed(4));
    s.setProperty('--copy-opacity',(1-copyOut).toFixed(3));
    s.setProperty('--copy-y',(-26*copyOut).toFixed(1)+'px');

    s.setProperty('--beat-1',bell(p,.14,.2,.28,.33).toFixed(3));
    s.setProperty('--beat-2',bell(p,.33,.39,.47,.52).toFixed(3));
    s.setProperty('--beat-3',bell(p,.52,.58,.66,.71).toFixed(3));

    s.setProperty('--bat-p',batP.toFixed(4));
    s.setProperty('--bat-o',bell(p,.1,.16,.62,.7).toFixed(3));

    s.setProperty('--fog-fade',(1-.8*smooth(.62,.84,p)).toFixed(3));
    s.setProperty('--fog-back-x',(-18+36*p).toFixed(1)+'px');
    s.setProperty('--fog-mid-x',(28-58*p).toFixed(1)+'px');
    s.setProperty('--fog-front-x',(-42+84*p).toFixed(1)+'px');

    s.setProperty('--finale',finale.toFixed(3));
    var on=finale>.02;
    if(on!==finaleOn){finaleOn=on;hero.classList.toggle('is-finale',on);}
  }

  function scrubTarget(p){
    var t=clamp((p-SCRUB_FROM)/(SCRUB_TO-SCRUB_FROM),0,1);
    return t*Math.max(0,duration-1/FPS);
  }

  function tick(){
    if(!inView){running=false;return;}
    var p=progress();
    paint(p);

    if(ready&&duration>0){
      var target=scrubTarget(p);
      var diff=target-shown;
      shown=Math.abs(diff)>0.6?target-Math.sign(diff)*0.6:shown+diff*EASE;
      if(Math.abs(target-shown)<0.002)shown=target;
      var frameTime=Math.round(shown*FPS)/FPS;
      if(!video.seeking&&Math.abs(video.currentTime-frameTime)>=1/FPS){
        video.currentTime=frameTime;
      }
      if(shown===target&&!video.seeking){running=false;return;}
    }else if(!loaded||!video){
      running=false;return;
    }
    requestAnimationFrame(tick);
  }

  function start(){
    if(!running&&inView){running=true;requestAnimationFrame(tick);}
  }

  function onReady(){
    if(ready)return;
    duration=video.duration||0;
    if(!duration)return;
    ready=true;
    shown=scrubTarget(progress());
    video.currentTime=Math.round(shown*FPS)/FPS;
    video.classList.add('is-ready');
    start();
  }

  function prime(){
    var attempt=video.play();
    if(attempt&&attempt.then){
      attempt.then(function(){video.pause();onReady();}).catch(function(){onReady();});
    }else{
      video.pause();onReady();
    }
  }

  function loadVideo(){
    if(loaded||!video||hero.classList.contains('is-static'))return;
    loaded=true;
    var src=video.getAttribute('data-src');
    if(!src)return;
    video.addEventListener('loadeddata',prime,{once:true});
    video.src=src;
    video.load();
  }

  if('IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      entries.forEach(function(e){inView=e.isIntersecting;});
      if(inView){measure();loadVideo();start();}
    },{rootMargin:'40% 0px 40% 0px'}).observe(hero);
  }else{
    inView=true;measure();loadVideo();start();
  }

  window.addEventListener('scroll',start,{passive:true});

  var lastW=window.innerWidth,lastH=window.innerHeight;
  window.addEventListener('resize',function(){
    var w=window.innerWidth,h=window.innerHeight;
    if(w!==lastW||Math.abs(h-lastH)>120){lastW=w;lastH=h;measure();lastProgress=-1;start();}
  },{passive:true});
  window.addEventListener('load',function(){measure();lastProgress=-1;paint(progress());start();});
  document.addEventListener('visibilitychange',function(){if(document.visibilityState==='visible'){measure();start();}});

  measure();
  paint(progress());
})();

/* ==========================================================
   Halloween decorations: corner cobwebs, dangling spiders,
   bats hanging under the header, an occasional flock.
   Pure SVG + CSS, injected once, pointer-events off.
   ========================================================== */
(function(){
  'use strict';
  if(window.__hwDeco||!document.body||!document.body.classList.contains('halloween-takeover'))return;
  window.__hwDeco=true;
  var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function web(R){
    var spokes=7,rings=[.16,.31,.47,.63,.79,.95],d='',ang=[];
    for(var i=0;i<spokes;i++){var a=(Math.PI/2)*(i/(spokes-1));if(i&&i<spokes-1)a+=Math.sin(i*7.3)*.05;ang.push(a);}
    ang.forEach(function(a){d+='M0 0L'+(Math.cos(a)*R).toFixed(1)+' '+(Math.sin(a)*R).toFixed(1);});
    rings.forEach(function(k){var r=R*k;for(var i=0;i<spokes-1;i++){var a1=ang[i],a2=ang[i+1],am=(a1+a2)/2,rc=r*.84;
      d+='M'+(Math.cos(a1)*r).toFixed(1)+' '+(Math.sin(a1)*r).toFixed(1)+'Q'+(Math.cos(am)*rc).toFixed(1)+' '+(Math.sin(am)*rc).toFixed(1)+' '+(Math.cos(a2)*r).toFixed(1)+' '+(Math.sin(a2)*r).toFixed(1);}});
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 '+R+' '+R+'"><path d="'+d+'" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/></svg>';
  }
  var WEB=web(200);
  var SPIDER='<svg xmlns="http://www.w3.org/2000/svg" viewBox="-20 -20 40 40"><g fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round">'+
    '<path d="M-3-3Q-10-11-15-7M-3-1Q-11-4-17 0M-3 2Q-10 5-15 11M-2 4Q-7 11-9 17"/>'+
    '<path d="M3-3Q10-11 15-7M3-1Q11-4 17 0M3 2Q10 5 15 11M2 4Q7 11 9 17"/></g>'+
    '<ellipse cx="0" cy="3.5" rx="5.2" ry="6.8" fill="currentColor"/><circle cx="0" cy="-4.6" r="3.6" fill="currentColor"/>'+
    '<circle cx="-1.4" cy="-5.1" r=".9" fill="#f0a060"/><circle cx="1.4" cy="-5.1" r=".9" fill="#f0a060"/></svg>';
  var HANG='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 28"><path d="M8 0v4" stroke="#7a5842" stroke-width="1"/>'+
    '<path fill="#140c09" d="M8 3.5c-2 0-3.2 1.6-3.6 3.4-.9-.8-2.4-.6-2.9.7 1.4.4 1.8 1.6 1.7 3.2C2.9 15 4 20 5.6 23l.6 3 1-1.8h1.6l1 1.8.6-3C12 20 13.1 15 12.8 10.8c-.1-1.6.3-2.8 1.7-3.2-.5-1.3-2-1.5-2.9-.7C11.2 5.1 10 3.5 8 3.5z"/>'+
    '<circle cx="6.6" cy="22" r=".7" fill="#e89a5a"/><circle cx="9.4" cy="22" r=".7" fill="#e89a5a"/></svg>';

  var css=[
    '.hw-web{position:absolute;top:0;z-index:1;width:clamp(92px,13vw,176px);color:rgba(236,224,206,.2);pointer-events:none;transform-origin:0 0;animation:hw-sway 9s ease-in-out infinite}',
    '.hw-web svg{display:block;width:100%;height:auto;overflow:visible}',
    '.hw-web--l{left:0}',
    '.hw-web--r{right:0;transform-origin:100% 0;animation-name:hw-sway-r}',
    '.hw-web--r svg{transform:scaleX(-1)}',
    '.hw-web--b{top:auto;bottom:0}.hw-web--b svg{transform:scaleY(-1)}.hw-web--b.hw-web--r svg{transform:scale(-1,-1)}',
    '.hw-web--sm{width:clamp(54px,6.5vw,82px);color:rgba(242,232,216,.34);z-index:3}',
    '@keyframes hw-sway{0%,100%{transform:rotate(0)}50%{transform:rotate(2deg)}}',
    '@keyframes hw-sway-r{0%,100%{transform:rotate(0)}50%{transform:rotate(-2deg)}}',
    '.hw-dangle{position:absolute;top:0;z-index:2;width:28px;margin-left:-14px;pointer-events:none;transform-origin:50% 0;animation:hw-pendulum 6.5s ease-in-out infinite}',
    '.hw-dangle__thread{display:block;width:1px;margin:0 auto;height:var(--len,110px);background:linear-gradient(rgba(236,224,206,0),rgba(236,224,206,.5));animation:hw-drop var(--dur,8s) ease-in-out infinite}',
    '.hw-dangle__spider{display:block;width:28px;height:28px;margin-top:-3px;color:#3a281e;filter:drop-shadow(0 0 3px rgba(245,190,130,.5))}',
    '.hw-dangle__spider svg{display:block;width:100%;height:100%;animation:hw-wiggle 2.8s ease-in-out infinite}',
    '@keyframes hw-pendulum{0%,100%{transform:rotate(2.5deg)}50%{transform:rotate(-2.5deg)}}',
    '@keyframes hw-drop{0%,100%{height:var(--len,110px)}45%{height:calc(var(--len,110px)*1.45)}60%{height:calc(var(--len,110px)*1.38)}}',
    '@keyframes hw-wiggle{0%,100%{transform:rotate(0)}25%{transform:rotate(7deg)}75%{transform:rotate(-7deg)}}',
    '.hw-hang{position:absolute;left:0;right:0;top:100%;height:0;pointer-events:none;z-index:5}',
    '.hw-hang i{position:absolute;top:0;width:15px;height:26px;transform-origin:50% 0;background:url("data:image/svg+xml,'+encodeURIComponent(HANG)+'") no-repeat 50% 0/contain;filter:drop-shadow(0 0 3px rgba(245,180,120,.4));animation:hw-swing var(--d,3s) ease-in-out infinite}',
    '@keyframes hw-swing{0%,100%{transform:rotate(7deg)}50%{transform:rotate(-7deg)}}',
    '@media(max-width:700px){.hw-hang i:nth-child(2n){display:none}.hw-dangle{transform:scale(.85)}}',
    '.hw-flock{position:fixed;left:0;top:0;width:0;height:0;z-index:40;pointer-events:none}',
    '.hw-flock__bat{position:absolute;left:0;top:0;opacity:0}',
    '.hw-flock__bat .hw-bat{display:block;width:38px;height:17px;background:#120b08;clip-path:polygon(0 18%,28% 38%,43% 8%,50% 44%,57% 8%,72% 38%,100% 18%,84% 92%,55% 66%,50% 100%,45% 66%,16% 92%);filter:drop-shadow(0 0 4px rgba(255,170,100,.5));animation:hw-flap2 .24s ease-in-out infinite alternate}',
    '@keyframes hw-flap2{from{transform:scaleY(1)}to{transform:scaleY(.4)}}',
    '.hw-flock__bat.is-flying{animation:hw-cross var(--t,7s) cubic-bezier(.37,0,.63,1) var(--dl,0s) 1 forwards}',
    '@keyframes hw-cross{0%{transform:translate3d(-60px,var(--y0),0) scale(var(--sc,1));opacity:0}6%{opacity:1}35%{transform:translate3d(35vw,calc(var(--y0) - 6vh),0) scale(var(--sc,1))}65%{transform:translate3d(68vw,calc(var(--y0) + 3vh),0) scale(var(--sc,1))}94%{opacity:1}100%{transform:translate3d(calc(100vw + 60px),calc(var(--y0) - 10vh),0) scale(var(--sc,1));opacity:0}}',
    '@media(prefers-reduced-motion:reduce){.hw-web,.hw-dangle,.hw-dangle__thread,.hw-dangle__spider svg,.hw-hang i{animation:none!important}.hw-flock{display:none}}'
  ].join('');
  var style=document.createElement('style');style.id='hw-deco-css';style.textContent=css;document.head.appendChild(style);

  function el(tag,cls,html){var e=document.createElement(tag);e.className=cls;e.setAttribute('aria-hidden','true');if(html)e.innerHTML=html;return e;}
  function host(h){if(h&&getComputedStyle(h).position==='static')h.style.position='relative';return h;}
  function addWeb(h,cls){if(!host(h))return;var w=el('div','hw-web '+cls,WEB);w.style.animationDelay=(-Math.random()*9).toFixed(1)+'s';h.appendChild(w);}
  function addSpider(h,left,len,dur){if(!host(h))return;var d=el('div','hw-dangle','<span class="hw-dangle__thread"></span><span class="hw-dangle__spider">'+SPIDER+'</span>');
    d.style.left=left+'%';d.style.setProperty('--len',len+'px');d.style.setProperty('--dur',dur+'s');d.style.animationDelay=(-Math.random()*6).toFixed(1)+'s';h.appendChild(d);}
  function q(s){return document.querySelector(s);}

  /* Sections: a web in one top corner, alternating sides */
  var secs=[].slice.call(document.querySelectorAll('main .night-intro, main .night-edit, main .sec, main .stmt'));
  secs.forEach(function(s,i){addWeb(s,i%2?'hw-web--l':'hw-web--r');});

  /* Spiders on a thread */
  addSpider(q('.night-intro'),86,150,8);
  addSpider(q('#rail'),7,120,9);
  addSpider(q('.halloween-home'),93,90,7);
  addSpider(q('#faq'),92,70,8.5);

  /* Small webs on the product photos */
  var photos=document.querySelectorAll('.night-card__photo');
  if(photos.length){addWeb(photos[0],'hw-web--r hw-web--sm');addWeb(photos[photos.length-1],'hw-web--l hw-web--sm');}

  /* Footer: webs in both top corners, one spider */
  var ftr=q('.ftr');
  if(ftr){addWeb(ftr,'hw-web--l');addWeb(ftr,'hw-web--r');addSpider(ftr,14,80,7.5);}

  /* Bats hanging under the header */
  var hdr=q('.hdr');
  if(hdr){host(hdr);var hang=el('div','hw-hang');
    [[9,3.1],[27,2.6],[63,3.6],[84,2.9],[93,3.3]].forEach(function(b){var i=document.createElement('i');i.style.left=b[0]+'%';i.style.setProperty('--d',b[1]+'s');i.style.animationDelay=(-Math.random()*3).toFixed(2)+'s';hang.appendChild(i);});
    hdr.appendChild(hang);}

  /* A small flock crossing the screen every so often */
  if(!reduced){
    var flock=el('div','hw-flock'),bats=[];
    for(var i=0;i<4;i++){var b=el('span','hw-flock__bat','<i class="hw-bat"></i>');flock.appendChild(b);bats.push(b);}
    document.body.appendChild(flock);
    var schedule=function(ms){setTimeout(fly,ms||22000+Math.random()*20000);};
    var fly=function(){
      if(document.visibilityState!=='visible')return schedule();
      var vh=window.innerHeight||800,baseY=vh*(.14+Math.random()*.34),n=2+Math.floor(Math.random()*3);
      bats.forEach(function(b,i){
        b.classList.remove('is-flying');
        if(i>=n)return;
        b.style.setProperty('--y0',Math.round(baseY+i*18+Math.random()*30)+'px');
        b.style.setProperty('--t',(6+Math.random()*2.5).toFixed(2)+'s');
        b.style.setProperty('--dl',(i*.35+Math.random()*.3).toFixed(2)+'s');
        b.style.setProperty('--sc',(.55+Math.random()*.5).toFixed(2));
        void b.offsetWidth;
        b.classList.add('is-flying');
      });
      schedule();
    };
    schedule(6000);
  }
})();
